/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { OAuthResponseDto } from '../../models/o-auth-response-dto';
import { OAuthSignUpDto } from '../../models/o-auth-sign-up-dto';

export interface OauthControllerSignUp$Params {

/**
 * 토큰
 */
  token: string;
      body: OAuthSignUpDto
}

export function oauthControllerSignUp(http: HttpClient, rootUrl: string, params: OauthControllerSignUp$Params, context?: HttpContext): Observable<StrictHttpResponse<OAuthResponseDto>> {
  const rb = new RequestBuilder(rootUrl, oauthControllerSignUp.PATH, 'post');
  if (params) {
    rb.query('token', params.token, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<OAuthResponseDto>;
    })
  );
}

oauthControllerSignUp.PATH = '/api/oauth/signup';
